export const Settings = ({abcd}) => {
    return (<div>Settings {abcd}</div>)
};